

























import { Component, Vue, Ref, Prop, Inject, Emit, Watch } from 'vue-property-decorator';
import createComponent from './widgetTsx';
import { AppModule } from '@/store/modules/app';
import widget from '@/views/sheet/widget/widgetInRecord';
let getFilter = JSON.parse(window.localStorage.getItem('VIEW_GETFILTERS') || '{}');
@Component({
	components: {
		createComponent,
		//  widget,
	},
})
export default class extends Vue {
	private show = false;
	// 保存筛选内容
	private filters: any = {
		businessId: '',
		fieldType: '',
		filterType: null,
		filterValue: '',
		minFilterValue: null,
		maxFilterValue: null,
		logicalType: 1,
	};
	// 用于保存筛选字段
	private selectField: any = {};
	// 暂时不做的筛选内容
	private filterArr = [
		'richText',
		'accessory',
		'associationTable',
		'timeLimit',
		'childTable',
		'cuttingLine',
		'remark',
		'autoNumber',
		'datetime',
		'dynamicTable',
		'externalComponent',
	];
	// 是的内容字段
	private isField = ['phone', 'email', 'region', 'cascadeSelect'];
	// 在范围内的内容字段
	private rangeField = [, 'number', 'autoNumber', 'statistics'];
	// 包含的内容字段
	private includeFields = ['checkbox', 'text', 'member', 'department'];
	private onSelect(value) {
		this.changeField(value);
		this.onChange();
	}
	private changeField(value) {
		if (value.fieldType === 'associationField') {
			this.selectField = value.sourceField;
			this.selectField.newFieldType = 'associationField';
			this.selectField.newBusinessId = value.businessId;
		} else {
			this.selectField = value;
		}
		this.filters.businessId = this.selectField.businessId;
		this.filters.fieldType = this.selectField.fieldType;
		this.filters.filterValue = '';
		this.filters.minFilterValue = null;
		this.filters.maxFilterValue = null;
		const simplify = this.simplify(this.selectField.fieldType);
		if (simplify(this.includeFields)) {
			// 表示包含字段
			this.filters.filterType = 1;
		} else if (simplify(this.rangeField)) {
			// 表示范围字段
			this.filters.filterType = 9;
		} else {
			// 表示是内容字段
			this.filters.filterType = 3;
		}
		this.show = false;
		getFilter[this.$route.params.viewId] = this.filters.businessId;
		window.localStorage.setItem('VIEW_GETFILTERS', JSON.stringify(getFilter));
		// this.onChange();
	}
	private simplify(fieldType) {
		return (arr) => {
			return arr.includes(fieldType);
		};
	}
	// 选项发生改变
	@Emit('search')
	private onChange() {
		!this.filters.minFilterValue
			? (this.filters.minFilterValue = null)
			: (this.filters.minFilterValue = this.filters.minFilterValue);
		!this.filters.maxFilterValue
			? (this.filters.maxFilterValue = null)
			: (this.filters.maxFilterValue = this.filters.maxFilterValue);
		if (this.filters.filterValue || this.filters.minFilterValue || this.filters.maxFilterValue) {
			if (this.selectField.newFieldType === 'associationField') {
				return [
					[
						{
							businessId: this.selectField.newBusinessId,
							fieldType: 'associationField',
							sourceFilter: Object.assign({}, this.filters, {
								businessId: this.selectField.businessId,
							}),
						},
					],
				];
			} else {
				return [[this.filters]];
			}
		} else {
			return '';
		}
	}
	// 筛选可选中的快捷选项
	get filterFieldList() {
		return (this.$store.state.sheet.sheetFieldList || []).filter((item) => {
			return (
				(item.fieldType !== 'associationField' && !this.filterArr.includes(item.fieldType)) ||
				(item.fieldType === 'associationField' &&
					!this.filterArr.includes(item.sourceField.fieldType))
			);
		});
	}
	private mounted() {
		this.getPublic();
	}
	private getPublic() {
		this.filters.businessId = getFilter[this.$route.params.viewId];
		this.filterFieldList.forEach((element) => {
			if (this.filters.businessId === element.businessId) {
				this.changeField(element);
			}
		});
	}
	@Watch('$route.params.viewId')
	private watcher() {
		this.selectField = {};
		this.getPublic();
	}
}
